module.exports = __webpack_public_path__ + "static/reviews-6ead623120deff5d5028de0b74c378a7.png";